const Constants = {
  httpAuthToken: "bearer obfMAswessMOadBilayIivzirAppppEmaiL",
  locale_en_EG: "en-EG",
  locale_ar_EG: "ar-EG",
  verifyMemberSubPath: "#verifymember",
};
export default Constants;
